/**
 * RitualProgressSection Component
 * Displays course progress for self-guided course rituals
 * Shown as a separate section below the info section on the ritual detail page
 */

interface CourseProgress {
  completedModules: number
  totalModules: number
  percentage: number
  showContinueCourse?: boolean
  showStartCourse?: boolean
}

interface RitualProgressSectionProps {
  courseProgress?: CourseProgress
  isOwner?: boolean
  isOrganizer?: boolean
}

export function RitualProgressSection({
  courseProgress,
  isOwner,
  isOrganizer,
}: RitualProgressSectionProps) {
  // Don't render if no progress data or if user is owner/organizer
  if (!courseProgress || isOwner || isOrganizer) {
    return null
  }

  return (
    <div className="rounded-[20px] border border-[#FFFFFF1A] bg-[#FFFFFF1A] px-5 py-4">
      <div className="flex gap-4">
        {/* Progress Label */}
        <div className="flex flex-col justify-between gap-1">
          <span className="text-[14px] font-medium text-primary">
            Progress {courseProgress.percentage}%
          </span>
          <span className="text-[14px] text-stone">
            Day {courseProgress.completedModules} of {courseProgress.totalModules} completed
          </span>
        </div>

        {/* Progress Bar */}
        <div className="flex-1 max-w-[200px]">
          <div className="w-[204px] h-[16px] border-1 border-[#F2F0EB]/10 bg-[#F2F0EB]/10 rounded-full overflow-hidden">
            <div
              className="h-full bg-[#5A5B3F] rounded-tl-full rounded-bl-full  transition-all"
              style={{ width: `${courseProgress.percentage}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
